import { render, staticRenderFns } from "./InterestForm.vue?vue&type=template&id=631566e0&"
import script from "./InterestForm.vue?vue&type=script&lang=js&"
export * from "./InterestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports